export default "__VITE_PUBLIC_ASSET__0e499af6__"